import React from 'react';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { TesseraRequestForm } from './TesseraRequestForm';
import { AttivitaRequestForm } from './AttivitaRequestForm';

export const VeCoPoint = () => {
  const points = [
    {
      city: 'Empoli',
      address: 'Via Jacopo Carrucci 46, 50053 Empoli (FI)',
      hours: 'Lunedì - Venerdì: 9:00 - 13:30 / 14:30 - 17:30',
      phone: '+39 0571 1657000',
      email: 'info@vetrinaconsulenti.it',
      mapUrl: 'https://goo.gl/maps',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      city: 'Pisa',
      address: 'Via San Iacopo 111, 56123 Pisa (PI)',
      hours: 'Lunedì - Venerdì: 9:00 - 13:00 / 14:30 - 17:30',
      phone: '+39 050 791 7282',
      email: 'info@vetrinaconsulenti.it',
      mapUrl: 'https://goo.gl/maps',
      color: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <section id="veco-point" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16">
            <Badge className="mb-6 bg-gradient-to-r from-teal-500 to-purple-600 border-0 text-base px-6 py-2">
              Ritira la Tua Tessera
            </Badge>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              VeCo Point
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Visita uno dei nostri punti per ritirare la tua tessera VeCo. 
              <span className="font-semibold"> Ricorda di portare un documento di identità.</span>
            </p>
          </div>

          {/* Points Grid */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {points.map((point, index) => (
              <Card key={index} className="border-2 border-gray-100 hover:border-teal-300 hover:shadow-2xl transition-all duration-300">
                <CardContent className="p-8">
                  {/* City Header */}
                  <div className={`inline-block bg-gradient-to-r ${point.color} text-white px-6 py-2 rounded-full mb-6`}>
                    <h3 className="text-2xl font-bold">{point.city}</h3>
                  </div>

                  {/* Info */}
                  <div className="space-y-4">
                    <div className="flex items-start">
                      <MapPin className="w-5 h-5 text-teal-600 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Indirizzo</p>
                        <p className="text-gray-900">{point.address}</p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <Clock className="w-5 h-5 text-purple-600 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Orari</p>
                        <p className="text-gray-900">{point.hours}</p>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <Phone className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Telefono</p>
                        <a href={`tel:${point.phone}`} className="text-teal-600 hover:underline">
                          {point.phone}
                        </a>
                      </div>
                    </div>

                    <div className="flex items-start">
                      <Mail className="w-5 h-5 text-orange-600 mr-3 mt-0.5 flex-shrink-0" />
                      <div>
                        <p className="text-sm font-medium text-gray-700 mb-1">Email</p>
                        <a href={`mailto:${point.email}`} className="text-teal-600 hover:underline">
                          {point.email}
                        </a>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Important Notice */}
          <Card className="bg-gradient-to-r from-teal-50 to-purple-50 border-2 border-teal-200">
            <CardContent className="p-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                Requisiti per il ritiro della tessera
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <div className="w-2 h-2 rounded-full bg-teal-600 mr-3 mt-2 flex-shrink-0" />
                  <p className="text-gray-700">Documento di identità valido (carta d'identità, patente o passaporto)</p>
                </li>
                <li className="flex items-start">
                  <div className="w-2 h-2 rounded-full bg-teal-600 mr-3 mt-2 flex-shrink-0" />
                  <p className="text-gray-700">Il ritiro è <span className="font-semibold">personale e gratuito</span></p>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Request Forms Section */}
      <div className="container mx-auto px-4 mt-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Tessera Request Form */}
            <TesseraRequestForm />
            
            {/* Attività Request Form */}
            <AttivitaRequestForm />
          </div>
        </div>
      </div>
    </section>
  );
};